import { IEntityReponse } from "../model/base/response/entity-response";

/**
 * Retorna o nickname da entidade em UPPERCASE
 * - Usa nickName se disponível, senão usa name como fallback
 *
 * @param entity - Objeto da entidade com nickName
 * @returns Nickname em UPPERCASE
 */
export const getFormattedEntityName = (entity: IEntityReponse | undefined): string => {
  if (!entity) {
    return '';
  }

  // Usa nickName se disponível, senão usa name como fallback
  const displayName = entity.nickName || entity.name;

  if (!displayName) {
    return '';
  }

  return displayName.toUpperCase();
};
